import { TextFieldProps } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import { BRAZILIAN_DATE_TIME_FORMAT } from "components/CRPComponents/JsonForm/dateDisplayConfig";

export const EVENT_DATE_TIME_SAVE_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";

type SurveyDateTimePickerProps = {
  label: string;
  value?: string;
  disabled?: boolean;
  required?: boolean;
  onChange: (value?: string) => void;
};

export function SurveyDateTimePicker({
  label,
  value,
  disabled,
  required,
  onChange,
}: SurveyDateTimePickerProps) {
  dayjs.locale("pt-br");
  const parsedValue = value ? dayjs(value) : null;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <DateTimePicker
        label={label}
        value={parsedValue?.isValid() ? parsedValue : null}
        onChange={(date) => {
          if (date === null) {
            onChange(undefined);
          } else if (date.isValid()) {
            onChange(date.format(EVENT_DATE_TIME_SAVE_FORMAT));
          }
        }}
        format={BRAZILIAN_DATE_TIME_FORMAT}
        ampm={false}
        views={["year", "day", "hours", "minutes"]}
        disabled={disabled}
        slotProps={{
          actionBar: ({ wrapperVariant }) => ({
            actions: wrapperVariant === "desktop" ? [] : ["clear", "cancel", "accept"],
          }),
          textField: {
            fullWidth: true,
            required,
            variant: "standard",
            inputProps: { type: "text", placeholder: "DD/MM/AAAA HH:mm" },
            InputLabelProps: value ? { shrink: true } : undefined,
          } as TextFieldProps,
        }}
      />
    </LocalizationProvider>
  );
}
